import { render, staticRenderFns } from "./Geral.vue?vue&type=template&id=dddec004&scoped=true"
import script from "./Geral.vue?vue&type=script&lang=js"
export * from "./Geral.vue?vue&type=script&lang=js"
import style0 from "./Geral.vue?vue&type=style&index=0&id=dddec004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddec004",
  null
  
)

export default component.exports